import { Box, Card, CircularProgress, Grid, Icon, IconButton } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { Form, Formik, useFormikContext } from "formik";
import FormField from "layouts/pages/users/new-user/components/FormField";
import PropTypes from "prop-types";
import { memo, useEffect, useState } from 'react';
import { errorAlert, successAlert } from "utils/Functions";
import { get, postNoResponse } from "utils/WebService";
import * as Yup from 'yup';

const FasePenhoraCreateEdit = ({ id, closeCreateEdit }) => {

    const { descricao } = configForm.formField

    const [isLoadingInfo, setIsLoadingInfo] = useState(false);

    const handleSubmit = (values, actions) => {
        const body = {
            id: values.id,
            descricao: values.descricao
        };

        postNoResponse("/fase-penhora/save", body)
            .then(() => {
                successAlert(!id ? "Fase de Penhora criada com sucesso!" : "Alterações salvas!", handleSucess());
            })
            .catch(() => {
                errorAlert(!id ? "Erro ao criar fase da penhora!" : 'Erro ao salvar alterações.');
            })
            .finally(() => {
                actions.setSubmitting(false);
            });
    };

    function handleSucess() {
        closeCreateEdit()
    }

    return (
        <Card id="user-info">
            <Box display="flex" alignItems="center" p={3}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1, paddingTop: 0.75 }}>
                    <MDTypography variant="h5">
                        <Icon>arrow_back</Icon>
                    </MDTypography>
                </IconButton>
                <MDTypography variant="h6">{id ? "Editar" : "Adicionar"} Fase da Penhora</MDTypography>
            </Box>
            <Formik
                initialValues={{
                    id: null,
                    descricao: '',
                }}
                validationSchema={validationSchema}
                onSubmit={(values, actions) => {
                    actions.setSubmitting(true);
                    handleSubmit(values, actions);
                }}>
                {({ values, errors, touched, isSubmitting }) => {
                    return (
                        <Form id={configForm.formId} autoComplete="off">
                            <FetchAndSetData
                                id={id}
                                setIsLoadingInfo={setIsLoadingInfo}
                                closeCreateEdit={closeCreateEdit} />

                            <MDBox px={3}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={descricao.type}
                                            label={descricao.label}
                                            name={descricao.name}
                                            value={values.descricao}
                                            placeholder={descricao.placeholder}
                                            error={errors.descricao?.length > 0 && touched.descricao}
                                        />
                                    </Grid>
                                </Grid>
                            </MDBox>
                            <Box display="flex" alignItems="center" justifyContent="end" p={2}>
                                <MDButton
                                    disabled={isLoadingInfo}
                                    size="large"
                                    variant="contained"
                                    color="info"
                                    circular={false}
                                    iconOnly={false}
                                    type="submit"
                                    endIcon={isSubmitting ?
                                        <CircularProgress
                                            color="inherit"
                                            size={20} sx={{ ml: 0, mr: 0 }} /> : null}>
                                    {!isSubmitting && (id ? "Salvar" : "Adicionar")}
                                </MDButton>
                            </Box>
                        </Form>)
                }}
            </Formik>
        </Card>
    );
};

FasePenhoraCreateEdit.propTypes = {
    id: PropTypes.string,
    closeCreateEdit: PropTypes.func.isRequired,
};

export default memo(FasePenhoraCreateEdit);

const FetchAndSetData = ({ id, setIsLoadingInfo, closeCreateEdit }) => {
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
        if (id) {
            setIsLoadingInfo(true);
            get(`/fase-penhora/by-id/${id}`).then(data => {
                const { id, descricao } = data;
                setFieldValue('descricao', descricao);
                setFieldValue('id', id);
                setIsLoadingInfo(false);
            }).catch(() => errorAlert("Fase de Penhora não encontrada!", closeCreateEdit));
        }
    }, [id]);

    return null;
};

export const configForm = {
    formId: "configuration-form",
    formField: {
        descricao: {
            name: "descricao",
            label: "Descrição",
            placeholder: "Informe a descrição...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
    }
}

const {
    formField: {
        descricao
    },
} = configForm;

export const validationSchema = Yup.object().shape({
    [descricao.name]: Yup.string()
        .required(descricao.errorMsg),
});
